import { render, staticRenderFns } from "./root.vue?vue&type=template&id=0d0155b7"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=0d0155b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/nuxt/components/Header.vue').default,Container: require('/app/nuxt/components/Container.vue').default,Footer: require('/app/nuxt/components/Footer.vue').default})
